import $ from 'jquery';
import Mustache from 'mustache';

export function useDialogTemplate(wizardListener) {
    function showDialog2(id, parameters) {
        const template = $('#' + id).html();
        const html = Mustache.render(template, parameters);
        const dialog = wizardListener.showDialog(id + '-auto', html);
        dialog.localize();
        return dialog;
    }

    return { showDialog2 };
}

export function useGuiHelper(wizardListener) {
    /**
     *
     * @param {string} [message]
     */
    const confirm2 = function(message) {
        return new Promise((resolve, reject) => {
            wizardListener.confirm(message, (err, result) => (err ? reject(err) : resolve(result)));
        });
    };
    /**
     *
     * @param {string} [message]
     * @param {info|success|error} [type]
     * @param {string} [title]
     */
    const alert2 = function(message, type, title) {
        wizardListener.errorMessageHandler(message, type, title);
    };
    const { showDialog2 } = useDialogTemplate(wizardListener);
    const waiting2 = function(show) {
        wizardListener.waiting(show);
    };
    return {
        confirm2,
        alert2,
        showDialog2,
        waiting2,
    };
}
